<template>
  <div class="main">
    <div class="main_item" :class="[routesCut == index ? 'main_item_active' : '']" v-for="(item, index) in userPermissionLists" :key="index" @click="getCut(index)">
      <img :src="getIcon(item.appName)" alt="" class="main_item_icon" />
      {{ item.appName }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      iconList: [
        {
          name: '租户管理',
          icon: require('../../assets/image/tenant-menu-icon.png'),
        },
        {
          name: '企业管理',
          icon: require('../../assets/image/enterprise-menu-icon.png'),
        },
        {
          name: '财务管理',
          icon: require('../../assets/image/finance-menu-icon.png'),
        },
        {
          name: '项目管理',
          icon: require('../../assets/image/project-menu-icon.png'),
        },
        {
          name: '招商租赁',
          icon: require('../../assets/image/investment-menu-icon.png'),
        },
        {
          name: '安防管理',
          icon: require('../../assets/image/iot-menu-icon.png'),
        },
        {
          name: '校园管理',
          icon: require('../../assets/image/school-menu-icon.png'),
        },
        {
          name: '社区管理',
          icon: require('../../assets/image/community-menu-icon.png'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['userPermissionLists']),
  },

  methods: {
    getIcon(appName) {
      if (!appName) return
      const index = this.iconList.findIndex(item => item.name === appName)
      if (index === -1) return
      return this.iconList[index].icon
    },
    async getCut(e) {
      this.$store.dispatch('permission/generateRoutesCut', e)
      const accessRoutes = await this.$store.dispatch('permission/generateRoutes', e)
      this.$router.addRoutes(accessRoutes)
      this.$router.push('/welcome/welcome')
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  height: 56px;
  display: flex;
  align-items: center;
  .main_item {
    width: 110px;
    height: 56px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.5s ease;
    cursor: pointer;
    .main_item_icon {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .main_item_active {
    background-color: rgba(255, 255, 255, 0.13);
  }
}
</style>
